import Compressor from "compressorjs";
export const ImageProcessor = {
  async process(file, options = {}) {
    if (!file) throw new Error("Archivo inválido");

    if (!file.type.startsWith("image/")) {
      return file;
    }

    const {
      quality = 0.7,
      maxWidth = 800,
      maxHeight = 800,
      mimeType = "image/webp"
    } = options;

    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality,
        maxWidth,
        maxHeight,
        mimeType,
        success: resolve,
        error: reject
      });
    });
  }
};